const Animate = {
  init() {
    this.events();
  },

  events() {
    // On load.
    this.elements();
    this.roll();

    // On scroll
    $(window).on("scroll", function () {
      Animate.elements();
      Animate.roll();
    });
  },

  elements() {
    var windowScrolled = $(window).scrollTop() + $(window).height();
    var index = 0;
    var prevOffset = 0;

    $(".animate")
      .not(".animate-animated")
      .each(function () {
        var block = $(this);
        var currentOffset = block.offset().top;

        if (prevOffset != currentOffset) {
          prevOffset = currentOffset;
          index = 0;
        }
        var showAt;
        if ($(window).width > 900) {
          // Show at 20% from bottom
          showAt = windowScrolled * 0.8;
        } else {
          // SHow at 5% from bottom
          showAt = windowScrolled * 0.95;
        }

        // Add class if in viewport
        if (currentOffset + block.height() < showAt || currentOffset < showAt) {
          // If multiple elements at the same top offset, add classes in chain
          setTimeout(function () {
            block.addClass("animate-animated");
          }, index * 100);
          index++;
        }
      });
  },

  roll() {
    var windowScrolled = $(window).scrollTop() + $(window).height();

    $(".roll")
      .not(".roll-rolled")
      .each(function () {
        var block = $(this);
        var currentOffset = block.offset().top;

        var showAt;
        if ($(window).width > 900) {
          // Show at 25% from bottom
          showAt = windowScrolled * 0.75;
        } else {
          // SHow at 5% from bottom
          showAt = windowScrolled * 0.95;
        }
        if (currentOffset + block.height() < showAt || currentOffset < showAt) {
          var count_to = block.data("count");
          if (typeof count_to === "number") {
            block.prop("Counter", 0).animate(
              {
                Counter: count_to,
              },
              {
                duration: 4000,
                easing: "swing",
                step(now) {
                  block.text(Math.ceil(now));
                },
              }
            );
          } else {
            block.text(count_to);
          }

          block.addClass("roll-rolled");
        }
      });
  },
};

export default Animate;
